
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/beneficiary/public-facility/[companyname]",
      function () {
        return require("private-next-pages/beneficiary/public-facility/[companyname].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/beneficiary/public-facility/[companyname]"])
      });
    }
  